import apiAssegurouAuto from '../../services/apiAssegurouAuto';
import type { VehicleModelResponseDTO } from '~/dto/Insurance/vehicleModelResponseDTO';
import type { YearVehicleModelEntity } from '~/domain/Insurance/yearsVehicleModelEntity';
import { yearVehicleModelResponseMapper } from '~/mappers/Insurance/yearVehicleModelResponseMapper';

export async function getYearsByVehicleModelUseCase(
  manufacturerId: string,
  model: string
): Promise<YearVehicleModelEntity> {
  try {
    const response = await apiAssegurouAuto.get<VehicleModelResponseDTO>(
      `/auto/getAnoModelo/1/${manufacturerId}/${model}`
    );
    return yearVehicleModelResponseMapper(response.data);
  } catch (error) {
    return {
      success: false,
      yearVehicleModels: [],
    };
  }
}
